<template>
  <fo-layout class="white-bg">
    <span slot="alt">{{vision.subtitle}}</span>
    <span slot="title">{{vision.title}}</span>
    <div class="mission-and-vision">
      <div class="mt-50">
        <div class="backimg centerimage" :style="'background-image: url(' + vision.big_img + '); height: 290px'"></div>
      </div>
      <div class="content-box show-mo">
        <a-row :gutter="30">
          <a-col :sm="12">
            <p class="fs-30 mb-20 black">{{vision.infoa_title}}</p>
            <p class="info to-3 mg-0">{{vision.infoa}}</p>
          </a-col>
          <a-col :sm="12">
            <p class="fs-30 mb-20 black">{{vision.infob_title}}</p>
            <p class="info to-3 mg-0">{{vision.infob}}</p>
          </a-col>
        </a-row>
      </div><div class="content-box show-pc">
        <a-row :gutter="100">
          <a-col :sm="12">
            <p class="fs-30 mb-20 black">{{vision.infoa_title}}</p>
            <p class="info to-3 mg-0">{{vision.infoa}}</p>
          </a-col>
          <a-col :sm="12">
            <p class="fs-30 mb-20 black">{{vision.infob_title}}</p>
            <p class="info to-3 mg-0">{{vision.infob}}</p>
          </a-col>
        </a-row>
      </div>
    </div>
  </fo-layout>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      vision: {
        title: '',
        subtitle: '',
        infoa_title: '',
        infoa: '',
        infob_title: '',
        infob: '',
        big_img: ''
      }
    }
  },
  watch: {
    'commonData.web_comp_vision' (obj) {
      this.vision = JSON.parse(obj.value)
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      this.vision = JSON.parse(this.commonData.web_comp_vision.value)
    }
  }
}
</script>

<style lang="less">
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .mission-and-vision {
    .content-box {
      width: 100%;
      color: #a1a3a6;
      margin-top: 70px;
      p {
        margin-bottom: 20px;
      }
    }
    .show-pc{
      display: none;
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .mission-and-vision {
    .content-box {
      width: 100%;
      color: #a1a3a6;
      margin-top: 70px;
    }
    .show-mo {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/missionAndVision.vue